import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { LoginDialogComponent } from 'src/app/shared/components/login-dialog/login-dialog.component';
@Component({
  selector: 'app-mobile-navbar',
  templateUrl: './mobile-navbar.component.html',
  styleUrls: ['./mobile-navbar.component.scss']
})
export class MobileNavbarComponent implements OnInit {
  public isHomeActive: boolean;
  public ripColor: any = '#00814d38';
  public isRewardsActive: boolean;
  public isStoresActive: boolean;
  public isMoreActive: boolean;
  public isPayActive: boolean;
  public isSearchActive: boolean;
  public isGiftActive: boolean;
  public isLoggedInUser: boolean;
  public imgurl;
  public home = {
    imgActive: 'assets/icon/home.svg',
    imgInActive: 'assets/icon/home_inactive.svg',
    text: 'Home'
  };
  public rewards = {
    imgActive: 'assets/icons/reward-dark.svg',
    imgInActive: 'assets/icon/timsrewards_ico.svg',
    text: 'Rewards'
  };
  public order = {
    imgActive: 'assets/icons/gps.svg',
    imgInActive: 'assets/icon/stores_ico.svg',
    text: 'Order'
  };
  public gift = {
    imgActive: 'assets/icon/Gift_Active.svg',
    imgInActive: 'assets/icon/gift_Inactive.svg',
    text: 'Gift'
  };
  public pay = {
    imgActive: 'assets/icon/pay-filled.svg',
    imgInActive: 'assets/icon/pay_Active.svg',
    text: 'Pay'
  };
  public search = {
    imgActive: 'assets/icon/Mask.svg',
    imgInActive: 'assets/icon/Serach_Active.svg',
    text: 'Search'
  };
  public isOpenBottomSheet = false;
  public currentRoute: any;
  public setZIndex = false;
  constructor(public router: Router, private commonFunction: CommonFunctions,   private dialog: MatDialog,) { }
  ngOnInit() {
    let currentUrl = window.location.href.split("/");

    if (currentUrl[currentUrl.length - 1] == "dashboard") {
      this.isHomeActive = true;
    } else {
      this.isHomeActive = false;
    }
  }
  homeMenu() {
    if (this.router.url == 'dashboard') {
      this.isHomeActive = true;
    } else {
      this.isGiftActive = false;
      this.isPayActive = false;
      this.isSearchActive = false;
      this.isRewardsActive = false;
    }
  }
  giftMenu() {
    this.isGiftActive = true;
    this.router.navigate(['/giftcards']);
  }
  rewardsMenu() {
  }

  storesMenu() {
  }
  moreMenu() {
  }
  payMenu() {
    this.isLoggedInUser = this.commonFunction.verifyLoggedInUser();
    if (this.isLoggedInUser == true) {
      this.router.navigate(['/pay']);
    } else {
      this.openLoginDialog();
    }
  }
  closeBottomSheet() {
    this.isSearchActive = true;
    this.router.navigate(['/search']);
  }
  public openLoginDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      redirectTo:'/pay',
      showBarista: true,
      message: 'This is a heading space to include brand content'
    };
    dialogConfig.disableClose = true;
    dialogConfig.minWidth='45vw';
    dialogConfig.maxWidth='70vw';
    const dialogRef = this.dialog.open(LoginDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

    });
  }
}
